// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"21":"8b9b0822","28":"d502b5ae","211":"bb8ce841","321":"52885fef","395":"f24576cb","453":"871c25b6","465":"6932a40b","885":"76633bb0"}[chunkId] + ".chunk.js";
};